module.exports = __webpack_public_path__ + "static/img/eiCad_cover_1.98937ad6.png";